import { render } from "./Passport.vue?vue&type=template&id=eb0040ba&scoped=true"
import script from "./Passport.vue?vue&type=script&lang=js"
export * from "./Passport.vue?vue&type=script&lang=js"

import "./Passport.vue?vue&type=style&index=0&id=eb0040ba&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb0040ba"]])

export default __exports__